"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var currencyApp = {
  free: {
    android: "https://play.google.com/store/apps/details?id=com.xe.currency&referrer=utm_source%3DWebsite%26utm_medium%3Dbutton%26utm_term%3Dget%2Bthe%2Bapp%26utm_campaign%3DGet%20the%20app",
    iOS: "https://itunes.apple.com/app/apple-store/id315241195?pt=211875&ct=Get%20the%20app&mt=8"
  }
};
exports.default = {
  currencyApp: currencyApp
};